export class GetSurveysIndex {
  static type = '[Index] - Get Surveys';
}
